<template>
  <v-container
    class="fill-height bg"
    fluid
  >
    <v-row 
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="ma-2">
          <v-card-title class="green accent-3">
            Reset Password
          </v-card-title>
          <v-card-text class="pa-4">
            <v-form ref="formPass" v-model="valid" lazy-validation>              
              <v-row v-if="isValid">
                <v-col cols="12">
                  <v-text-field
                    label="Masukkan password baru"
                    type="password"
                    v-model="newPass"
                    outlined
                    :rules="[ rules.required, rules.minPass ]"                    
                  ></v-text-field>
                </v-col>   
                <v-col cols="12">
                  <v-text-field
                    label="Konfirmasi password baru"
                    type="password"
                    v-model="newPass2"
                    outlined
                    :rules="[ rules.required, rules.minPass, rules.passwordConfirm(newPass) ]"
                  ></v-text-field>
                </v-col>      
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn color="success" dark @click="simpanClick" v-if="isValid">Simpan</v-btn>
            <v-btn color="info" dark to="/" v-if="!isValid">Home</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>      
  </v-container>
</template>

<script>
import { rules as Rules } from './../../lib/rules'
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'

export default {
  data: function() {
    return {
      valid: true,
      newPass: '',
      newPass2: '',
      userId: '',
      email: '',
      isValid: false,
      expired: false,
      jenisError: '',
      rules: {
        required: Rules.required,
        passwordConfirm: Rules.passwordConfirm,
        minPass: value => value.length >= this.$store.getters.PANJANG_MIN_PASSWD || `Password minimal ${this.$store.getters.PANJANG_MIN_PASSWD} karakter`,
      },
      batal: 'Batal',
      daftarDone: false,
      kodeUrl: ''
    }
  },
  created: async function() {
    this.kodeUrl = this.$route.params.kodeUrl
    await axios.post(apiUrl+'/member/activity', { kodeUrl: this.kodeUrl })
    .then((response) => {
      this.email = response.data.data.email
      this.userId = response.data.data.userId 
      this.isValid = true
    })
    .catch((error) => {
      const errMsg = JSON.parse(error.response.data.message)      
      this.jenisError = errMsg.jenis
      this.expired = this.jenisError === 'EXP' ? true : false
      this.$store.dispatch('displayAlert', {
        color: 'error', 
        message: errMsg.message })
      window.scroll(0,0)
    })
  },
  computed: {
    Batal: function() {
      return this.daftarDone ? 'Kembali ke Home' : 'Batal'
    }
  },
  methods: {
    simpanClick: async function() {
      const mess = {
        userId: this.userId,
        email: this.email,
        newPass: this.newPass,
        kodeUrl: this.kodeUrl,
        kind: 'R'
      }
      await axios.put(apiUrl+'/userman/respwd', mess)
      .then((response) => {
        console.log(response)
        this.$store.dispatch('displayAlert', {color: 'success', message: 'Password telah berhasil diubah'})
        window.scroll(0,0)
        this.isValid = false
        this.$router.push({ name: 'Login' }); 
      })
      .catch((err) => {
        this.$store.dispatch('displayAlert', {color: 'error', message: err.response.data.message})
        window.scroll(0,0)
      })      
    }
  }
}
</script>

<style scoped>

</style>